export enum AreaOverlayType {
  CIRCLE = 'circle',
  POLYGON = 'polygon',
  EMD = 'emd',
}

export enum AnalyticsAreaType {
  Radius = 'Radius',
  Polygon = 'Polygon',
  AdministrativeBuilding = 'AdministrativeBuilding',
}

export enum CoordType {
  Point = 'Point',
  Polygon = 'Polygon',
  MultiPoint = 'MultiPoint',
  MultiPolygon = 'MultiPolygon',
  LineString = 'LineString',
  MultiLineString = 'MultiLineString',
}

export enum AreaAnalyticsFilter {
  HOUSE_HOLD = 'household',
  DAYCARE_CENTER = 'daycareCenter',
  KINDERGARTEN = 'kindergarten',
  ELEMENTARY_SCHOOL = 'elementary',
  MIDDLE_SCHOOL = 'middle',
  HIGH_SCHOOL = 'high',
  UNIVERSITY = 'university',
  HOSPITAL = 'hospital',
  SUBWAY = 'subway',
  BUS = 'bus',
  ANALYTICS_TYPE = 'analyticsType',
  LOCATION_TYPE = 'locationType',
  PRESUME_POPULATION = 'presumePopulation',
  MULTI_POLYGON = 'multiPolygon',
  ACADEMY = 'academy',
  HOME_ELDERLY_WELFARE = 'homeElderlyWelfare',
  HOUSEHOLD_MEMBER = 'householdMember',
  UPCOMMING_APTS = 'upcomingAparts',
  AVERAGE = 'average',
  HOUSE = 'house', // 단독주택,
  ADMIN_CODES = 'admCodes',
  PUBLIC_OFFICE = 'publicOffice', // 관공서
}

export enum BuildingType {
  Apartment = 'APT',
  Officetel = 'OFFICE',
  HOUSE = 'HOUSE',
  Villa = 'VILLA',
}

export enum DeliveryServiceType {
  baemin = 'baemin',
  coupangeats = 'coupangeats',
  yogiyo = 'yogiyo',
}

export enum AnalysisTabType {
  ai = 'ai',
  basic = 'basic',
  footTraffic = 'footTraffic',
  customer = 'customer',
  station = 'station',
  hospital = 'hospital',
  childcare = 'childcare',
  school = 'school',
  stores = 'stores',
  hallSales = 'hallSales',
  delivery = 'delivery',
}

export enum SchoolItemKoreanType {
  '초등학교' = AreaAnalyticsFilter.ELEMENTARY_SCHOOL,
  '중학교' = AreaAnalyticsFilter.MIDDLE_SCHOOL,
  '고등학교' = AreaAnalyticsFilter.HIGH_SCHOOL,
  '대학교' = AreaAnalyticsFilter.UNIVERSITY,
}
